var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.885 11.236c1.856-1.075 3.73-2.15 5.585-3.224a1.76 1.76 0 0 1 1.804 0l2.763 1.578a.247.247 0 0 1 .085.327.248.248 0 0 1-.085.09l-6.752 3.884a.553.553 0 0 0-.276.487v3.26a.523.523 0 0 0 .275.467l2.826 1.63a.5.5 0 0 0 .54 0l11.653-6.71c1.978-1.144 1.978-4.44 0-5.584L17.827 1.404a2.796 2.796 0 0 0-2.895 0L4.456 7.44A2.865 2.865 0 0 0 3 9.954c0 4.03.017 8.064 0 12.087a2.87 2.87 0 0 0 1.456 2.517l10.476 6.053a2.884 2.884 0 0 0 2.895 0l10.476-6.052a2.828 2.828 0 0 0 1.44-2.517v-5.248l-12.469 7.21a1.773 1.773 0 0 1-1.804 0l-5.563-3.227a1.76 1.76 0 0 1-.904-1.56V12.78a1.78 1.78 0 0 1 .884-1.544h-.002z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXec);
export default __webpack_public_path__ + "static/media/XEC.2377c0bed0fb2f881c6f54a6f9ddba77.svg";
export { ForwardRef as ReactComponent };